import { Fragment } from "react";
import {
    Button,
    Link,
    Grid,
    Dialog,
    DialogTitle,
    DialogActions,
    DialogContent,
    DialogContentText,
    CircularProgress,
    Typography,
    Box
} from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { styled } from "@mui/material/styles";
import esperando from "../../../assets/images/icons/esperando.png";

const ContentStyle = styled("div")(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    position: "fixed",
    backgroundColor: "#E2E7EE",
    bottom: 0,
    left: 0,
    width: "100%",
    height: "72px",
    padding: "0 25px",
    zIndex: 1200,
    [theme.breakpoints.down("sm")]: {
        flexDirection: "column",
        height: "auto",
        padding: "10px",
    },
}));

const ModalStyle = styled("div")(() => ({
    // Se deja vacío por si se desea añadir estilos adicionales
}));

export default function Footer(props) {
    const {
        RefSubmit,
        isOpenModalSave,
        clickOpenCloseModalSave,
        size1,
        textDetail,
        size2,
        textButton1,
        isLoadingButton1,
        color,
        isSubmitButton2,
        disabledButton2,
        textButton2,
        onClickButton1,
        isLoadingButton2,
        onClickButton2,
    } = props;

    return (
        <Fragment>
            <ModalStyle>
                <Dialog
                    open={!!isOpenModalSave}
                    onClose={clickOpenCloseModalSave || undefined}
                    maxWidth="xs"
                    sx={{ textAlign: "center" }}
                >
                    <Box sx={{ paddingTop: "20px" }}>
                        <img
                            src={esperando}
                            alt="footerimg"
                            height="132"
                            width="180"
                            style={{ margin: "auto" }}
                        />
                    </Box>
                    <DialogTitle sx={{ padding: "10px" }}>
                        Tus datos se guardaron con éxito.
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText sx={{ color: "#212B36" }}>
                            Puedes retomar el proceso de afiliación cuando tengas más tiempo.
                            No olvides continuar lo más pronto posible.
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ justifyContent: "center", paddingTop: "1px !important" }}>
                        <Button onClick={clickOpenCloseModalSave} variant="outlined">
                            Cerrar esta ventana
                        </Button>
                    </DialogActions>
                </Dialog>
            </ModalStyle>

            <ContentStyle>
                <Grid container alignItems="center">
                    <Grid
                        item
                        xs={12}
                        sm={size1 || 6}
                        sx={{
                            textAlign: { xs: "center", sm: "left" },
                            mb: { xs: 1, sm: 0 }
                        }}
                    >
                        {textDetail && (
                            <Typography >{textDetail}</Typography>
                        )}
                    </Grid>

                    <Grid
                        item
                        xs={12}
                        sm={size2 || 6}
                        sx={{
                            textAlign: { xs: "center", sm: "right" }
                        }}
                    >
                        {textButton1 && isLoadingButton1 ? (
                            <CircularProgress
                                size={24}
                                sx={{ verticalAlign: "middle", mr: { sm: "6%", xs: 1 } }}
                            />
                        ) : (
                            textButton1 && (
                                <Link
                                    component="button"
                                    onClick={onClickButton1}
                                    underline="none"
                                    disabled={!!isLoadingButton2}
                                    sx={{
                                        mr: { sm: 2, xs: 1 },
                                        cursor: "pointer",
                                        color: "#E40046"
                                    }}
                                >
                                    <Typography variant="body1">{textButton1}</Typography>
                                </Link>
                            )
                        )}

                        {textButton2 && (
                            <LoadingButton
                                color={color || "primary"}
                                size="large"
                                type={isSubmitButton2 ? "submit" : "button"}
                                variant="contained"
                                onClick={onClickButton2}
                                loading={!!isLoadingButton2}
                                disabled={disabledButton2 || isLoadingButton1}
                            >
                                {textButton2}
                            </LoadingButton>
                        )}
                    </Grid>
                </Grid>
            </ContentStyle>
        </Fragment>
    );
}
